// extracted by mini-css-extract-plugin
export var container = "_ld-0";
export var dotAnimation = "_ld-2";
export var dotsLoading = "_ld-1";